import {Row, Col, message} from "antd";
import Sidebar from "./sidebar";
import { Outlet, useNavigate } from "react-router-dom";
import { userStore, getUserProfile } from "../../store/userStore";
import { useEffect, useState } from "react";


export default function DashboardBody(){
    const navigate = useNavigate();
    const setUser = userStore(state=>state.setUser);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    useEffect(()=>{
        const synchronizeUserAuth = async ()=>{
            try{
                const user = await getUserProfile();
                if(!user){
                    message.error("User unauthenticated");
                    return navigate("/login");
                }
                setUser({...user});
                return;
            }catch(err){
                navigate("/login");
                throw err;
            }
        }

        synchronizeUserAuth();
    }, []);

    // Listen for sidebar collapse state changes
    const handleSidebarCollapse = (collapsed) => {
        setSidebarCollapsed(collapsed);
    };

    return(
        <>
        <div className="container">
            <Row style={{position:"relative"}}>
                <Col
                    className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}
                    style={{
                        width: sidebarCollapsed ? '70px' : 'auto',
                        flex: sidebarCollapsed ? '0 0 70px' : '0 0 25%'
                    }}
                >
                    <Sidebar onCollapse={handleSidebarCollapse}/>
                </Col>
                <Col
                    className="main"
                    style={{
                        width: sidebarCollapsed ? 'calc(100% - 70px)' : 'calc(100% - 25%)',
                        flex: sidebarCollapsed ? '1 1 calc(100% - 70px)' : '1 1 75%',
                        transition: 'all 0.3s ease'
                    }}
                >
                    <div style={{minHeight:"140vh"}}>
                     <Outlet/>
                    </div>
                </Col>
            </Row>
        </div>
        </>
    )
}
